import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

export default class extends Controller {
  static get values() {
    return { folderManagementUrl: String }
  }

  static get targets() {
    return ["nameInput"]
  }

  updateColor(event) {
    TempFormHelper.create(`${this.folderManagementUrlValue}/${event.target.dataset.id}`, "patch", (form) => {
      TempFormHelper.addHiddenInput(form, "folder[color]", event.target.value)
    }).requestSubmit()
  }

  updateName(event) {
    TempFormHelper.create(`${this.folderManagementUrlValue}/${event.target.dataset.id}`, "patch", (form) => {
      TempFormHelper.addHiddenInput(form, "folder[name]", this.nameInputTarget.value)
    }).requestSubmit()
  }
}
